import React from 'react';
import FiltersPanel from './FiltersPanel';

const FiltersSidebar = (props) => {
  return (
    <aside className="sticky top-24 hidden w-full max-w-[280px] shrink-0 overflow-y-auto rounded-3xl border border-slate-200 bg-white p-5 lg:block max-h-[calc(100vh-8rem)]">
      <FiltersPanel {...props} />
    </aside>
  );
};

export default FiltersSidebar;
